import AddFeedbackNamIT from "./AddFeedbackNAMIT";

const AddInvFeedbackNAMIT = () => {
  return <AddFeedbackNamIT isEdit={false} />;
};

export default AddInvFeedbackNAMIT;
